import { Tabs } from 'antd'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import './TabCommon.scss'

const { TabPane } = Tabs

export const TabCommon = ({
	size = 'default',
	tabs,
	activeKey,
	onChange,
	centered,
}) => {
	return (
		<Tabs
			className={classNames('tabs-common', `size-${size}`)}
			defaultActiveKey="1"
			activeKey={activeKey}
			onChange={onChange}
			centered={centered}
		>
			{tabs.map(item => (
				<TabPane tab={item.title} key={item.keyTab || item.title}>
					{item.component}
				</TabPane>
			))}
		</Tabs>
	)
}

TabCommon.propTypes = {
	tabs: PropTypes.array,
	activeKey: PropTypes.number,
	onChange: PropTypes.func,
	size: PropTypes.oneOf(['default', 'small']),
	centered: PropTypes.bool,
}
